// src/theme/colors.ts
export const colours = {
    primary: {
      main: '#130F26',      // Dark purple (as shown in sidebar)
      light: '#211C3C',     // Lighter version
      dark: '#0A0817',      // Darker version
      contrastText: '#FFFFFF'
    },
    secondary: {
      main: '#5A4FCF',      // Purple accent color
      light: '#6D62E3',     // Lighter version
      dark: '#483DB8',      // Darker version
      contrastText: '#FFFFFF'
    },
    background: {
      default: '#F8F9FA',   // Light gray background
      paper: '#FFFFFF',     // White content area
      dark: '#130F26',      // Dark background (sidebar)
     grey: '#E9EDF0'
    },
    text: {
      primary: '#333333',
      secondary: '#555555',
      disabled: '#999999',
      inverse: '#FFFFFF'    // White text on dark backgrounds
    },
    success: {
      main: '#27AE60',      // Success state
      light: '#2ECC71',
      dark: '#219653'
    },
    warning: {
      main: '#F39C12',      // Warning state
      light: '#F1C40F',
      dark: '#D35400'
    },
    error: {
      main: '#E74C3C',      // Error state (delete buttons)
      light: '#F5B7B1',
      dark: '#C0392B'
    },
    info: {
      main: '#3498DB',      // Information state
      light: '#3AA3F4',
      dark: '#2980B9'
    },
    border: '#E0E0E0', 
    borders: {
        default:'#DDDDDD',
    },     // Border color for tables and cards
    icon: {
      view: '#6B7280',      // View icon color
      edit: '#6B7280',      // Edit icon color
      delete: '#E74C3C'     // Delete icon color
    }
  };